import { z } from 'zod';
import { registerSchema } from '@erikdakoda/utils/schemaRegistry';

const ProgramDailyIntentionSchema = z.object({
  intention: z.string(),
});

const ProgramDesignResultSchema = z.object({
  programId: z.string(),
  handle: z.string(),
  warnings: z.array(z.string()),
});

/**
 * Registers program-related output schemas for interview steps.
 * Safe to call on every app init (re-registers on HMR).
 */
export function registerProgramOutputSchemas(): void {
  registerSchema({
    app: 'uvilo-ai',
    name: 'program-daily-intention',
    version: 1,
    zodSchema: ProgramDailyIntentionSchema,
    format: {},
  });
  registerSchema({
    app: 'uvilo-ai',
    name: 'program-design-result',
    version: 1,
    zodSchema: ProgramDesignResultSchema,
    format: {},
  });
}
